// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3WsPV{display:none}@media (min-width:600px){._3WsPV{display:block}}html[dir=rtl] ._3WsPV{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}", ""]);
// Exports
exports.locals = {
	"icon": "_3WsPV"
};
module.exports = exports;
